<swiper-container #swiperContainer init="false" class="swiper-container">
  <swiper-slide *ngFor="let item of carouselItems">
    <ng-container [ngTemplateOutlet]="item.itemTemplate"></ng-container>
  </swiper-slide>
</swiper-container>

<button #navButtonPrev class="swiper-button left" [hidden]="showNavButtons === false" title="Previous Slide">
  @if(customArrows) {
    <ng-content select="[customPrev]"></ng-content>
  }
  @else {
    <span class="swiper-button swiper-button--prev"></span>
  }
</button>
<button #navButtonNext class="swiper-button right" [hidden]="showNavButtons === false" title="Next Slide">
  @if (customArrows) {
    <ng-content select="[customNext]"></ng-content>
  }
  @else {
    <span class="swiper-button swiper-button--next"></span>
  }
</button>
